var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data !== undefined
    ? _c(
        "div",
        { class: ["sub-values", { inline: _vm.data === null }] },
        [
          _vm.data === null
            ? _c(
                "div",
                {
                  staticClass: "sub-value clickable",
                  on: {
                    click: function($event) {
                      return _vm.$emit("click")
                    }
                  }
                },
                [
                  _c("div", { staticClass: "label" }, [
                    _vm._v("Keine Ausbildung nötig")
                  ])
                ]
              )
            : [
                _c(
                  "div",
                  {
                    staticClass: "sub-value clickable",
                    on: {
                      click: function($event) {
                        return _vm.$emit("click")
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "label" }, [
                      _vm._v("Art der Ausbildung")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("Label", {
                          attrs: {
                            characteristic: _vm.data.schoolType,
                            "label-type": _vm.labelTypeJobProfile
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.data.professions
                  ? _c(
                      "div",
                      {
                        staticClass: "sub-value clickable",
                        on: {
                          click: function($event) {
                            return _vm.$emit("click")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("Fachliche Schwerpunkte")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("LabelList", {
                              attrs: {
                                characteristics: _vm.getCharacteristicsLastLevel(
                                  _vm.data.professions
                                ),
                                "label-type": _vm.labelTypeJobProfile
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }